import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";
import urls from "../../../Utils/urls";
import { toast } from "react-toastify";
import {
  commonToast,
  getMonthFromString,
  groupByObj,
  reduceSum,
} from "../../../Utils";

export const fetchLoanSubmissions = createAsyncThunk(
  "loanSubmissions/fetchLoanSubmissions",
  async ({ signal }) => {
    try {
      const res = await axios.get(
        urls.submitaLoan.getLoanSubmissions(
          localStorage.getItem("apex_userid")
        ),
        { signal }
      );

      let data = res.data.submissions;
      const finarlResult = data?.map((item) => {
        const newItem = {};
        newItem["loan_no"] = item["liLoanNumber"] || "";
        newItem["address"] = item["cciAddress"] || "";
        newItem["loan_amount"] = item["liLoanAmount"] || "";
        newItem["next_due_date"] = item["imNextInstallmentDue"] || "";
        newItem["status"] = item["status"] || "";
        newItem["action"] = "-";
        return newItem;
      });
      return finarlResult;
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Fetch request canceled", error.message);
      } else {
        // console.error(error);
        console.error(error);
        toast.error(`Loan Submissions Error`, {
          ...commonToast,
        });
      }
      return [];
    }
  }
);
export const fetchLoanBoarded = createAsyncThunk(
  "loanSubmissions/fetchLoanBoarded",
  async ({ lenderId, signal }) => {
    try {
      const res = await axios.get(urls.submitaLoan.getLoanNumber(lenderId), {
        signal,
      });
      let data = res?.data?.[0] || [];
      data = data?.map((data2) => ({
        ...data2,
        Month: getMonthFromString(data2.Months.substring(0, 3)),
        Year: data2.Years,
      }));
      const yearData = reduceSum(
        data
          ?.filter((data2) => data2.Year === new Date().getFullYear())
          ?.map((data3) => data3["Number of Loans"])
      );

      const monthData = reduceSum(
        data
          ?.filter(
            (data2) =>
              data2.Year === new Date().getFullYear() &&
              data2.Month === new Date().getMonth() + 1
          )
          ?.map((data3) => data3["Number of Loans"])
      );

      return { yearToDate: yearData, monthToDate: monthData };
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Fetch request canceled", error.message);
      } else {
        // console.error(error);
        console.error(error);
        toast.error(`Loan Boarded Error`, {
          ...commonToast,
        });
      }

      return { yearToDate: 0, monthToDate: 0 };
    }
  }
);
export const fetchLoanValue = createAsyncThunk(
  "loanSubmissions/fetchLoanValue",
  async ({ lenderId, signal }) => {
    try {
      const res = await axios.get(urls.submitaLoan.getLoanValues(lenderId), {
        signal,
      });
      let data = res?.data?.[0] || [];
      const keys = Object.keys(groupByObj(data, "Year"));
      const values = Object.values(groupByObj(data, "Year"));
      const emptyarr = values?.map((element) => {
        const newElement = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        element?.forEach((data) => {
          newElement[data.Month - 1] = +data["FundControl"];
        });
        return newElement;
      });
      const result = keys.reduce(
        // eslint-disable-next-line no-sequences
        (acc, curr, index) => ((acc[curr] = []), acc),
        {}
      );
      keys?.forEach((data, index) => {
        result[data] = emptyarr[index];
      });
      return { loanValue: result, loanYears: keys };
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Fetch request canceled", error.message);
      } else {
        console.error(error);
        toast.error(`Loan Value Error`, {
          ...commonToast,
        });
      }
      return { yearToDate: 0, monthToDate: 0 };
    }
  }
);
export const fetchLoanNumber = createAsyncThunk(
  "loanSubmissions/fetchLoanNumber",
  async ({ lenderId, signal }) => {
    try {
      const res = await axios.get(urls.submitaLoan.getLoanNumber(lenderId), {
        signal,
      });
      let data = res?.data?.[0] || [];
      data = data?.map((data2) => ({
        ...data2,
        Month: getMonthFromString(data2.Months.substring(0, 3)),
        Year: data2.Years,
      }));
      const keys = Object.keys(groupByObj(data, "Years"));
      const values = Object.values(groupByObj(data, "Years"));
      const emptyarr = values?.map((element) => {
        const newElement = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        element?.forEach((data) => {
          newElement[data.Month - 1] = +data["Number of Loans"];
        });
        return newElement;
      });
      const result = keys.reduce(
        // eslint-disable-next-line no-sequences
        (acc, curr, index) => ((acc[curr] = []), acc),
        {}
      );
      keys?.forEach((data, index) => {
        result[data] = emptyarr[index];
      });
      return { loanValue: result, loanYears: keys };
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Fetch request canceled", error.message);
      } else {
        console.error(error);
        toast.error(`Loan Value Error`, {
          ...commonToast,
        });
      }

      return { yearToDate: 0, monthToDate: 0 };
    }
  }
);
